import React, { useEffect, useState } from 'react'
import LogoRed from '../../img/parts/logo/logo_3_red.png'
import LogoBlue from '../../img/parts/logo/logo_3_blue.png'

const TitleBar = () => {
  const [boolean, setBoolean] = useState<boolean>()
  useEffect(() => {
    const getRandomBoolean = () => {
      return Math.random() < 0.5 // 0から1の範囲でランダムな数を生成し、その値が0.5未満ならtrue、それ以外ならfalseを返す
    }
    setBoolean(getRandomBoolean())
  }, [boolean])
  return (
    <div className="sticky top-0 z-50  flex h-12 items-center overscroll-contain bg-nemoBlue pl-6 text-justify text-white shadow xl:h-16">
      <a href="/nemo2024/home">
        <div className="my-2 transform rounded-full px-1 transition-transform duration-300 hover:scale-105 hover:bg-sky-400">
          <img
            src={boolean ? LogoRed : LogoBlue}
            alt="title"
            className="h-10 py-1 xl:h-14"
          />
        </div>
      </a>
    </div>
  )
}

export default TitleBar
